export default __webpack_public_path__ + "static/media/tijd_verdelen.39635ba7.jpg";